import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon"]

  connect() {
    this.applyTheme()

    // Listen for system preference changes (only matters when preference is "system")
    this.mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
    this.systemChangeHandler = () => {
      if (this.getPreference() === "system") this.applyTheme()
    }
    this.mediaQuery.addEventListener("change", this.systemChangeHandler)
  }

  disconnect() {
    this.mediaQuery.removeEventListener("change", this.systemChangeHandler)
  }

  toggle() {
    const current = this.getPreference()
    let next
    if (current === "system") {
      // System → opposite of current resolved theme
      next = this.systemPrefersDark() ? "light" : "dark"
    } else if (current === "dark") {
      next = "light"
    } else {
      next = "dark"
    }
    this.setPreference(next)
    this.applyTheme()
  }

  applyTheme() {
    const pref = this.getPreference()
    const isDark = pref === "dark" || (pref === "system" && this.systemPrefersDark())

    if (isDark) {
      document.documentElement.classList.add("dark")
    } else {
      document.documentElement.classList.remove("dark")
    }

    this.updateIcon(isDark)

    // Notify other controllers (grid_bg, divider)
    window.dispatchEvent(new CustomEvent("themeChanged", { detail: { dark: isDark } }))
  }

  updateIcon(isDark) {
    if (!this.hasIconTarget) return
    // Sun icon in dark mode (click to go light), moon icon in light mode (click to go dark)
    this.iconTarget.innerHTML = isDark
      ? '<svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="5"/><path d="M12 1v2m0 18v2M4.22 4.22l1.42 1.42m12.72 12.72l1.42 1.42M1 12h2m18 0h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/></svg>'
      : '<svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"/></svg>'
  }

  getPreference() {
    return this.getCookie("theme") || "system"
  }

  setPreference(value) {
    document.cookie = `theme=${value};path=/;max-age=${365 * 24 * 60 * 60};SameSite=Lax`
  }

  getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
    return match ? match[2] : null
  }

  systemPrefersDark() {
    return window.matchMedia("(prefers-color-scheme: dark)").matches
  }
}
